import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import {
  Box,
  Button,
  Divider,
  MenuItem,
  Modal,
  TextField,
  Typography
} from '@mui/material';

import LoadingButton from '../../../../../components/buttons/Button';

import {
  UpdateEntryDocumentBIZcoreTD
} from '../../../../../redux/actions/business/core/entryDocumentsActions';

import global from "../../../../../global.scss";

const MODES = { EDIT: 2 };

const Data = {
  StorageUrl: "",
  IsParsed: false,
};

const EntryDocumentsModal = ({
  open,
  setOpen,
  title,
  update,
  handleGet
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(Data);
  const [mode, setMode] = useState(MODES.EDIT);

  const handleClose = () => {
    setOpen(false);
    setFormData(Data);
    setMode(MODES.EDIT);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    try {
      if (open) {
        if (update.defaultMode === MODES.EDIT) {
          setMode(MODES.EDIT);
          setFormData({
            StorageUrl: update.storage_url || "",
            IsParsed: update.is_parsed !== undefined ? update.is_parsed : false,
          });
        } else {
          toast.error("Invalid modal");
          handleClose();
        }
      }
    } catch (err) {
      console.log(err);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleSubmit = () => {
    const obj = {
      storage_url: formData.StorageUrl,
      is_parsed: formData.IsParsed,
    };
    if (mode === MODES.EDIT) {
      dispatch(UpdateEntryDocumentBIZcoreTD(update.id, obj, setLoading)).then(() => {
        handleGet(setLoading).then(() => {
          handleClose();
        });
      });
    } else {
      toast.error("Invalid modal");
      handleClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className="flexCenterCenterRow" width={"100vw"} height={"100vh"}>
        <Box maxWidth={"sm"} className="modal">
          <Box width={"100%"} sx={{ padding: "15px" }}>
            <Typography variant='h6'
              sx={{ color: global["primary"] }} mb={"20px"}>
              {title}
            </Typography>

            {/* Storage URL */}
            <Box mb={"15px"}>
              <TextField
                label="Storage URL"
                fullWidth
                name="StorageUrl"
                value={formData.StorageUrl}
                onChange={handleChange}
              />
            </Box>

            {/* Is Parsed */}
            <Box mb={"15px"}>
              <TextField
                select
                label="Is parsed"
                fullWidth
                name="IsParsed"
                value={formData.IsParsed}
                onChange={handleChange}
              >
                <MenuItem value={true}>Yes</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </TextField>
            </Box>
          </Box>
          <Divider sx={{ backgroundColor: "rgba(44, 45, 47, 1)" }} />
          <Box className="flexCenterFERow" sx={{ gap: "20px", margin: "15px" }}>
            <Button variant='text' onClick={handleClose}>
              Cancel
            </Button>
            <LoadingButton
              variant='contained'
              loading={loading}
              disabled={!formData.StorageUrl}
              onClick={handleSubmit}>
              Submit
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default EntryDocumentsModal;
